import React from 'react';

import { Select as RSelect } from 'twyne-new.ui';

import { useProps, useClassName } from 'components/pure/hooks';

const { propTypes } = RSelect
const imutableProps = {}
const mutableProps = {}

const classNames = {}

export default function Creatable({ children, className, ...props }) {
  className = useClassName(classNames, className)

  return <RSelect {...useProps(props, imutableProps)} className={className} children={children} creatable />
}

Creatable.propTypes = propTypes
Creatable.defaultProps = mutableProps
